import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { connectRequest, querySelectors } from 'redux-query/advanced';
import { getUserProfile, appUserProfileSelector } from 'src/queries/userProfile';
import { RootState } from 'src/reducers/rootReducer';
import { getUser } from '@virtus/common/auth/aadWrapper';
import config from 'src/config';
import menuItems from 'src/comps/Inspector/DateRangeInspector/DateRangeMenuItems';
//import { getDecodedTokenInfo } from '@virtus/common/auth/idpWrapper';

export interface DefaultProfileConfig {
  DefaultGridRows: number; 
  DefaultTimeRange: string;
  DefaultUseSignalR: boolean;
}

export type ReduxProps = {
  isLoading: boolean;
  userProfile: any;
};

interface OwnProps {
  readonly children: (state: ReduxProps) => React.ReactNode;
}

type Props = ReduxProps & OwnProps;

//let userName: string;



const GetDefaultProfile = () => {
  // if(config !== undefined && config.useIDP !== undefined && config.useIDP) {
  //   userName = getDecodedTokenInfo().EmailAddress;
  // } else {
  //  userName = getUser().idToken.emails[0];
  // }
  try {
    return {   
      UserName: getUser().username, 
      //UserName: userName,
      DefaultGridRows: config.defaultProfile.DefaultGridRows,
      DefaultTimeRange: config.defaultProfile.DefaultTimeRange,
      DefaultUseSignalR: config.defaultProfile.DefaultUseSignalR,
    }
  }
  catch(e) {
    return {    
      UserName: '',
      DefaultGridRows: config.defaultProfile.DefaultGridRows,
      DefaultTimeRange: config.defaultProfile.DefaultTimeRange,
      DefaultUseSignalR: config.defaultProfile.DefaultUseSignalR,
    }
  }
}

export function GetLocalStateProfile()  {
  let userProfile = localStorage.getItem('USER_PROFILE_LOCAL');
  if(userProfile === undefined || userProfile === null || userProfile === '') {
    return GetDefaultProfile();
  }
  return JSON.parse(userProfile);
}

export function GetItemText() {
  let userProfile = GetLocalStateProfile();
  let item = menuItems.get(userProfile.DefaultTimeRange);
  if(item === undefined) {
    return '';
  }
  return item;
}

const getDefaultTimeRange = () => {
  let userProfile = GetLocalStateProfile();
  return userProfile.DefaultTimeRange;
}

export function GetTimeRange() {
  let userProfile = GetLocalStateProfile();
  return userProfile.DefaultTimeRange;
}

export const GetGridRows = (): number => {
  let userProfile = GetLocalStateProfile();
  return userProfile.DefaultGridRows;
}

const AdminUserProfile = ({ isLoading, userProfile, children }: Props) => {  
  if(userProfile === undefined || userProfile === null) {
    userProfile = GetDefaultProfile();
  }

  return children({ isLoading, userProfile });
}

const mapStateToProps = (state: RootState): ReduxProps => {
  const isLoading = querySelectors.isPending(state.queries, getUserProfile(getUser().username))
  return {
    isLoading,
    userProfile: appUserProfileSelector(state),
  };
};

const mapPropsToConfigs = () => [
 getUserProfile(getUser().username)
];

export default compose<any>(
  connect(mapStateToProps),
  connectRequest(mapPropsToConfigs),
)(AdminUserProfile);
